<template>
  <div>
    <Title title="Not Found" description="URLが正しくありません。もう一度ご確認ください。" />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
export default {
  name: 'NotFound',
  components: {
    Title
  }
}
</script>
